import { HostListener, Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';

import { environment } from 'projects/doc-gen/src/environments/environment';
// environment.<env>.ts defined using the --configurations:<env> switch
// during 'ng build' thru fileReplacements in angular.json, see https://angular.io/guide/build

@Injectable({
  providedIn: 'root',
})
export class SseService {
  sseUrl: string = environment.apiUrl + '/api/v1' + environment.sseUrl + '/subscribe';
  eventSource: EventSource;

  /**
   * Closes SSE connection on window close or page refresh
   */
  @HostListener('window:beforeunload', ['$event']) beforeUnloadHandler() {
    this.closeSseConnection();
  }

  /**
   * function to be subscribed by caller, new messages from server
   * will be emitted as new value for subscriber
   * @param url string for sse endpoint
   * @returns Observable with new events sent by server
   */
  openSseConnection(): Observable<Event> {
    this.eventSource = new EventSource(this.sseUrl);
    /* return observable updated by open, message or error event */
    return new Observable((observer: Observer<Event>) => {
      this.eventSource.onopen = event => {
        observer.next(event);
      };

      this.eventSource.onmessage = event => {
        observer.next(event);
      };

      this.eventSource.onerror = error => {
        observer.next(error);
      };
    });
  }

  /**
   * request to close sse connection
   */
  closeSseConnection() {
    this.eventSource.close();
  }
}
